export interface IStazione {
  id?: string,
  codice: string,
  descrizione: string,
  latitudine: string,
  longitudine: string,
  inGestione: boolean,
  wallet: number,
  fondo: number,
  isElevazioneRuolo: boolean
}

export interface IStazioneTratta {
  id?: string,
  idTratta?: string,
  idStazione?: string,
  codice: string,
  descrizione: string,
}

export enum TipoStazione {
  "ENTRATA" = "ENTRATA",
  "USCITA" = "USCITA",
  "ALL" = "ALL"
}